module.exports = __webpack_public_path__ + "img/top_right-last.8a3e0f46.jpg";